import { ITransactions } from "../transactions.types";
import { SupplierCell } from "./styles";

export const TransactionSupplierCell = (transaction: ITransactions) => {
  return <SupplierCell href={`/supplier/${transaction.supplierId}`}>{transaction.supplierName}</SupplierCell>;
};
